import { CurrentSubscription, Plan } from '../types';
import { ANNUAL, MONTHLY } from '../Constants';

const isMonthlySubscription = (subscription: CurrentSubscription) => {
  const cycle = subscription?.subscriptionOption?.cycle ?? '';

  return cycle === MONTHLY;
};

const isAnnualSubscription = (subscription: CurrentSubscription) => {
  const cycle = subscription?.subscriptionOption?.cycle ?? '';

  return cycle === ANNUAL;
};

const canSwitchBillingCycle = (
  subscription: CurrentSubscription,
  otherSubscriptionOption: CurrentSubscription,
) => otherSubscriptionOption && subscription.paymentSourceOnFile;

const getSubscriptionOptionsFromPlan = (plan: Plan) => {
  const subscriptionOptions = plan?.subscriptionOptions?.edges ?? [];

  return subscriptionOptions.map(({ node }) => node);
};

export {
  isMonthlySubscription,
  isAnnualSubscription,
  canSwitchBillingCycle,
  getSubscriptionOptionsFromPlan,
};
